import React from "react";
import { BookingStatus, firstName } from "../bookingStatus";

interface Props {
  booking: any;
  status: BookingStatus;
  isHost: boolean;
}

const BADGE: Record<BookingStatus, { label: string; cls: string }> = {
  booking_request: { label: "Request sent", cls: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300" },
  invoice_sent: { label: "Payment due", cls: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300" },
  payment_received: { label: "Payment received", cls: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300" },
  confirmed: { label: "Confirmed", cls: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300" },
  canceled: { label: "Canceled", cls: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300" },
};

const BookingHeader: React.FC<Props> = ({ booking: b, status, isHost }) => {
  const badge = BADGE[status];
  const guest = isHost ? firstName(b?.request_by) : "";
  const title = isHost ? `Booking request${guest ? ` from ${guest}` : ""}` : b?.property?.title;
  const shared = b?.is_shared_property === true || b?.is_shared_property === "true";
  const sub = [
    shared ? b?.booked_room : null,
    [b?.property?.neighborhood, b?.property?.city].filter(Boolean).join(", "),
    b?.number ? `Booking ${b.number}` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <header className="flex flex-col gap-3">
      <a
        href={isHost ? "/manage_bookings" : "/my_bookings"}
        className="inline-flex min-h-[44px] w-fit items-center gap-1.5 text-sm font-medium text-[#C2410C] dark:text-[#FF8A6E] hover:underline"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        All bookings
      </a>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 flex-1 basis-80">
          <h1 className="text-2xl font-semibold leading-tight text-neutral-900 dark:text-white sm:text-[28px]">{title}</h1>
          {sub && <p className="mt-1.5 text-sm text-neutral-500 dark:text-neutral-400">{sub}</p>}
        </div>
        <span className={`inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold ${badge.cls}`}>{badge.label}</span>
      </div>
    </header>
  );
};

export default BookingHeader;
